import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, withKeys as _withKeys, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card-body pt-6 pb-4 learning-form umt-form" }
const _hoisted_2 = {
  key: 0,
  class: "fw-bolder text-primary text-uppercase fs-5 ps-3 border-start border-4 border-primary mb-5",
  style: {"font-weight":"700 !important"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-exclamation-triangle-fill text-warning me-2" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "fw-semibold" }, "Còn thiếu:", -1)
const _hoisted_5 = { class: "row g-5" }
const _hoisted_6 = { class: "col-xl-4 col-12" }
const _hoisted_7 = { class: "border border-gray-300 border-dashed rounded p-5 h-100" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-wrap align-items-center umt-section-hdr fs-6 text-uppercase mb-4 pb-2 border-bottom border-gray-200" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "badge badge-circle hdr-num-badge me-2 fs-8",
    style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
  }, "1"),
  /*#__PURE__*/_createTextVNode(" Trường lớp 12 ")
], -1)
const _hoisted_9 = { class: "row g-4" }
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-2 required" }, "Tỉnh / Thành phố", -1)
const _hoisted_12 = { class: "text-muted fs-8 mt-2" }
const _hoisted_13 = { class: "fw-bold text-gray-700" }
const _hoisted_14 = { class: "col-12" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-2 required" }, [
  /*#__PURE__*/_createTextVNode("Trường "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-normal fs-8" }, "· gõ tên để tìm")
], -1)
const _hoisted_16 = { class: "text-muted fs-8 mt-2" }
const _hoisted_17 = { class: "fw-bold text-gray-700" }
const _hoisted_18 = { class: "col-xl-4 col-12" }
const _hoisted_19 = { class: "border border-gray-300 border-dashed rounded p-5 h-100" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center umt-section-hdr fs-6 text-uppercase mb-4 pb-2 border-bottom border-gray-200" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "badge badge-circle hdr-num-badge me-2 fs-8",
    style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
  }, "2"),
  /*#__PURE__*/_createTextVNode(" Trường lớp 11")
], -1)
const _hoisted_21 = { class: "row g-4" }
const _hoisted_22 = { class: "col-12" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-2 required" }, "Tỉnh / Thành phố", -1)
const _hoisted_24 = { class: "text-muted fs-8 mt-2" }
const _hoisted_25 = { class: "fw-bold text-gray-700" }
const _hoisted_26 = { class: "col-12" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-2 required" }, [
  /*#__PURE__*/_createTextVNode("Trường "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-normal fs-8" }, "· gõ tên để tìm")
], -1)
const _hoisted_28 = { class: "text-muted fs-8 mt-2" }
const _hoisted_29 = { class: "fw-bold text-gray-700" }
const _hoisted_30 = { class: "col-xl-4 col-12" }
const _hoisted_31 = { class: "border border-gray-300 border-dashed rounded p-5 h-100" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center umt-section-hdr fs-6 text-uppercase mb-4 pb-2 border-bottom border-gray-200" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "badge badge-circle hdr-num-badge me-2 fs-8",
    style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
  }, "3"),
  /*#__PURE__*/_createTextVNode(" Trường lớp 10")
], -1)
const _hoisted_33 = { class: "row g-4" }
const _hoisted_34 = { class: "col-12" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-2 required" }, "Tỉnh / Thành phố", -1)
const _hoisted_36 = { class: "text-muted fs-8 mt-2" }
const _hoisted_37 = { class: "fw-bold text-gray-700" }
const _hoisted_38 = { class: "col-12" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-2 required" }, [
  /*#__PURE__*/_createTextVNode("Trường "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-normal fs-8" }, "· gõ tên để tìm")
], -1)
const _hoisted_40 = { class: "text-muted fs-8 mt-2" }
const _hoisted_41 = { class: "fw-bold text-gray-700" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", {
  for: "checkSameClass12",
  class: "ms-2 text-muted fs-7 cursor-pointer"
}, [
  /*#__PURE__*/_createElementVNode("i", null, "Điền nhanh: Lớp 11 và lớp 10 giống trường lớp 12")
], -1)
const _hoisted_43 = { class: "border border-gray-300 border-dashed rounded p-5 mb-5" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center umt-section-hdr fs-6 text-uppercase mb-4 pb-2 border-bottom border-gray-200" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "badge badge-circle hdr-num-badge me-2 fs-8",
    style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
  }, "4"),
  /*#__PURE__*/_createTextVNode(" Tốt nghiệp & Ưu tiên")
], -1)
const _hoisted_45 = { class: "row g-5 align-items-end" }
const _hoisted_46 = { class: "col-md-4" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-2 required" }, "Năm tốt nghiệp", -1)
const _hoisted_48 = { class: "col-md-4" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-semibold mb-2",
  title: "Số báo danh kỳ thi tốt nghiệp THPT — dùng đối chiếu điểm thi từ Bộ GD&ĐT"
}, [
  /*#__PURE__*/_createTextVNode("Số báo danh "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-normal fs-8" }, "· thi TN THPT")
], -1)
const _hoisted_50 = { class: "col-md-4" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-normal fs-8" }, "· nếu TN năm trước", -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-2 required" }, "Đối tượng ưu tiên", -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-2 required" }, "Khu vực ưu tiên", -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-2 d-block" }, "Điểm ưu tiên tạm tính", -1)
const _hoisted_55 = { class: "c-umt3rd fs-2 fw-bolder pt-1" }
const _hoisted_56 = { class: "d-flex align-items-center umt-section-hdr fs-6 text-uppercase mb-3 pb-2 border-bottom border-gray-200" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("span", {
  class: "badge badge-circle hdr-num-badge me-2 fs-8",
  style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
}, "5", -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil-square me-1" }, null, -1)
const _hoisted_59 = { class: "table-responsive" }
const _hoisted_60 = { class: "table table-row-dashed table-row-gray-200 align-middle gy-1 mb-0 umt-table" }
const _hoisted_61 = { class: "border-bottom border-gray-200" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("th", null, "Lớp", -1)
const _hoisted_63 = ["title"]
const _hoisted_64 = { class: "fw-semibold text-gray-800 text-nowrap" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-8 fst-italic mt-3" }, [
  /*#__PURE__*/_createTextVNode("Dùng để hệ thống "),
  /*#__PURE__*/_createElementVNode("b", null, "tự chọn tổ hợp xét học bạ tốt nhất"),
  /*#__PURE__*/_createTextVNode(" khi tạo hồ sơ PT2. Môn không học để trống.")
], -1)
const _hoisted_66 = {
  style: {"max-height":"calc(100vh - 2rem)","overflow-y":"auto","overflow-x":"hidden"},
  class: "umt-form"
}
const _hoisted_67 = { class: "d-flex align-items-center justify-content-between mb-2 px-3 pt-2" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder fs-4 m-0" }, "Nhập bảng điểm học bạ THPT", -1)
const _hoisted_69 = { class: "svg-icon svg-icon-2 m-0" }
const _hoisted_70 = { class: "card-body py-3" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-8 fst-italic mb-3" }, [
  /*#__PURE__*/_createTextVNode("Điểm "),
  /*#__PURE__*/_createElementVNode("b", null, "TB cả năm"),
  /*#__PURE__*/_createTextVNode(" (0–10). Gõ điểm rồi nhấn "),
  /*#__PURE__*/_createElementVNode("b", null, "Enter"),
  /*#__PURE__*/_createTextVNode(" để nhảy "),
  /*#__PURE__*/_createElementVNode("b", null, "xuống môn kế cùng lớp"),
  /*#__PURE__*/_createTextVNode(" (hết cột tự sang lớp kế). Môn không học để trống.")
], -1)
const _hoisted_72 = { class: "border border-gray-300 border-dashed rounded p-4 mb-4" }
const _hoisted_73 = { class: "table table-row-dashed table-row-gray-200 align-middle mb-0 umt-table w-100 transcript-drawer-table" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "border-bottom border-gray-200" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px" }, "Môn"),
    /*#__PURE__*/_createElementVNode("th", { class: "w-100px text-center" }, "Lớp 10"),
    /*#__PURE__*/_createElementVNode("th", { class: "w-100px text-center" }, "Lớp 11"),
    /*#__PURE__*/_createElementVNode("th", { class: "w-100px text-center" }, "Lớp 12")
  ])
], -1)
const _hoisted_75 = { class: "fw-semibold text-gray-800" }
const _hoisted_76 = { class: "d-flex justify-content-between align-items-center py-2" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fs-8 fst-italic" }, [
  /*#__PURE__*/_createTextVNode("Điểm sẽ được lưu khi bấm "),
  /*#__PURE__*/_createElementVNode("b", null, "Lưu thay đổi"),
  /*#__PURE__*/_createTextVNode(" của tab.")
], -1)
const _hoisted_78 = { class: "d-flex align-items-center umt-section-hdr fs-6 text-uppercase mb-3 pb-2 border-bottom border-gray-200" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("span", {
  class: "badge badge-circle hdr-num-badge me-2 fs-8",
  style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
}, "6", -1)
const _hoisted_80 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil-square me-1" }, null, -1)
const _hoisted_81 = { class: "table-responsive" }
const _hoisted_82 = { class: "table table-row-dashed table-row-gray-200 align-middle gy-1 mb-0 umt-table" }
const _hoisted_83 = { class: "border-bottom border-gray-200" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_85 = ["title"]
const _hoisted_86 = /*#__PURE__*/_createElementVNode("td", { class: "fw-semibold text-gray-800 text-nowrap" }, "Điểm thi", -1)
const _hoisted_87 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-8 fst-italic mt-3" }, [
  /*#__PURE__*/_createTextVNode("Điểm thi từng môn — dùng để "),
  /*#__PURE__*/_createElementVNode("b", null, "tự đổ điểm khi tạo hồ sơ PT1"),
  /*#__PURE__*/_createTextVNode(" (xét kết quả thi TN THPT); sửa điểm trong hồ sơ PT1 sẽ ghi ngược về đây. Môn không thi để trống.")
], -1)
const _hoisted_88 = {
  style: {"max-height":"calc(100vh - 2rem)","overflow-y":"auto","overflow-x":"hidden"},
  class: "umt-form"
}
const _hoisted_89 = { class: "d-flex align-items-center justify-content-between mb-2 px-3 pt-2" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder fs-4 m-0" }, "Nhập điểm thi tốt nghiệp THPT", -1)
const _hoisted_91 = { class: "svg-icon svg-icon-2 m-0" }
const _hoisted_92 = { class: "card-body py-3" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-8 fst-italic mb-3" }, [
  /*#__PURE__*/_createTextVNode("Điểm thi (0–10, tối đa 2 số lẻ). Gõ điểm rồi nhấn "),
  /*#__PURE__*/_createElementVNode("b", null, "Enter"),
  /*#__PURE__*/_createTextVNode(" để xuống môn kế. Môn không thi để trống.")
], -1)
const _hoisted_94 = { class: "border border-gray-300 border-dashed rounded p-4 mb-4" }
const _hoisted_95 = { class: "table table-row-dashed table-row-gray-200 align-middle mb-0 umt-table w-100" }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "border-bottom border-gray-200" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px" }, "Môn"),
    /*#__PURE__*/_createElementVNode("th", { class: "w-100px text-center" }, "Điểm thi")
  ])
], -1)
const _hoisted_97 = { class: "fw-semibold text-gray-800" }
const _hoisted_98 = { class: "text-center" }
const _hoisted_99 = { class: "d-flex justify-content-between align-items-center py-2" }
const _hoisted_100 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted fs-8 fst-italic" }, [
  /*#__PURE__*/_createTextVNode("Điểm sẽ được lưu khi bấm "),
  /*#__PURE__*/_createElementVNode("b", null, "Lưu thay đổi"),
  /*#__PURE__*/_createTextVNode(" của tab.")
], -1)
const _hoisted_101 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center umt-section-hdr fs-6 text-uppercase mb-4 pb-2 border-bottom border-gray-200" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "badge badge-circle hdr-num-badge me-2 fs-8",
    style: {"min-width":"22px","min-height":"22px","width":"22px","height":"22px"}
  }, "7"),
  /*#__PURE__*/_createTextVNode(" Bằng tốt nghiệp Trung cấp / Cao đẳng ")
], -1)
const _hoisted_102 = { class: "row g-5" }
const _hoisted_103 = { class: "col-12" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-2" }, "Trường tốt nghiệp", -1)
const _hoisted_105 = { class: "col-md-3" }
const _hoisted_106 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-2" }, "Hình thức đào tạo", -1)
const _hoisted_107 = { class: "col-md-2" }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-2" }, "Hệ", -1)
const _hoisted_109 = { class: "col-md-4" }
const _hoisted_110 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-2 d-block" }, "Thang điểm", -1)
const _hoisted_111 = { class: "col-md-3" }
const _hoisted_112 = { class: "form-label fw-semibold mb-2" }
const _hoisted_113 = { class: "text-muted fw-normal fs-8" }
const _hoisted_114 = { class: "col-md-3" }
const _hoisted_115 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-2" }, "Số hiệu bằng tốt nghiệp", -1)
const _hoisted_116 = { class: "col-md-3" }
const _hoisted_117 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-2" }, "Số vào sổ TN", -1)
const _hoisted_118 = { class: "col-md-3" }
const _hoisted_119 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-2" }, "Năm tốt nghiệp", -1)
const _hoisted_120 = { class: "col-md-3" }
const _hoisted_121 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-2" }, "Ngày cấp bằng", -1)
const _hoisted_122 = { class: "mt-5 pt-4 border-top border-gray-200" }
const _hoisted_123 = { class: "form-check form-check-custom form-check-solid align-items-center" }
const _hoisted_124 = /*#__PURE__*/_createElementVNode("span", { class: "fw-semibold" }, "Thí sinh tốt nghiệp cao đẳng theo hình thức liên thông từ Trung cấp", -1)
const _hoisted_125 = /*#__PURE__*/_createElementVNode("div", { class: "fw-semibold text-gray-700 fs-6 mb-1" }, "Thông tin tốt nghiệp Trung cấp", -1)
const _hoisted_126 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-8 fst-italic mb-4" }, "Bằng Trung cấp đã dùng để học liên thông lên Cao đẳng.", -1)
const _hoisted_127 = { class: "row g-5" }
const _hoisted_128 = { class: "col-md-4" }
const _hoisted_129 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-2" }, "Trường tốt nghiệp", -1)
const _hoisted_130 = { class: "col-md-4" }
const _hoisted_131 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-2" }, "Hình thức đào tạo", -1)
const _hoisted_132 = { class: "col-md-4" }
const _hoisted_133 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-2" }, "Năm tốt nghiệp", -1)
const _hoisted_134 = { class: "col-md-4" }
const _hoisted_135 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-2" }, "Số hiệu bằng tốt nghiệp", -1)
const _hoisted_136 = { class: "col-md-4" }
const _hoisted_137 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-2" }, "Số vào sổ TN", -1)
const _hoisted_138 = { class: "col-md-4" }
const _hoisted_139 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-semibold mb-2" }, "Ngày cấp bằng", -1)
const _hoisted_140 = { class: "d-flex align-items-center justify-content-between flex-wrap gap-2 mt-4" }
const _hoisted_141 = { class: "text-muted fs-8 fst-italic" }
const _hoisted_142 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil-square me-1" }, null, -1)
const _hoisted_143 = {
  key: 1,
  class: "text-end umt-sticky-footer"
}
const _hoisted_144 = ["disabled"]
const _hoisted_145 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`card ${_ctx.cardClasses}`)
  }, [
    _createVNode(_component_el_form, {
      onSubmit: _cache[40] || (_cache[40] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
      model: _ctx.formData,
      rules: _ctx.rules,
      ref: "formRef"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_ctx.sectionTitle)
            ? (_openBlock(), _createElementBlock("h3", _hoisted_2, _toDisplayString(_ctx.sectionTitle), 1))
            : _createCommentVNode("", true),
          _withDirectives(_createVNode(_component_el_alert, {
            type: "warning",
            closable: false,
            class: "umt-warn-banner mb-5"
          }, {
            title: _withCtx(() => [
              _hoisted_3,
              _hoisted_4,
              _createTextVNode(" " + _toDisplayString(_ctx.missingImportant.join(', ')), 1)
            ]),
            _: 1
          }, 512), [
            [_vShow, _ctx.missingImportant.length]
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createVNode(_component_el_select, {
                      "popper-class": "umt-form-dd",
                      class: "w-100",
                      placeholder: "Tỉnh / Thành phố",
                      modelValue: _ctx.formData.class12ProvinceId,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.class12ProvinceId) = $event)),
                      onChange: _ctx.schoolProcess12ProvinceChange,
                      filterable: true,
                      disabled: !_ctx.isEdit
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataProvinceForSchool, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.name,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange", "disabled"]),
                    _createElementVNode("div", _hoisted_12, [
                      _createTextVNode("Mã tỉnh: "),
                      _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.dataProvinceForSchool.find(i => i.id === _ctx.formData.class12ProvinceId)?.code || '—'), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _createVNode(_component_el_select, {
                      "popper-class": "umt-form-dd",
                      class: "w-100",
                      placeholder: "Chọn / gõ tìm trường",
                      modelValue: _ctx.formData.class12SchoolId,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.class12SchoolId) = $event)),
                      onChange: _ctx.schoolProcess12SchoolNameChange,
                      disabled: _ctx.schoolProcess12SchoolNameOption.length == 0 || !_ctx.isEdit,
                      filterable: true
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.schoolProcess12SchoolNameOption, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.districtName ? `${item.name} - ${item.districtName}` : item.name,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange", "disabled"]),
                    _createElementVNode("div", _hoisted_16, [
                      _createTextVNode("Mã trường: "),
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.schoolProcess12SchoolNameOption.find(i => i.id === _ctx.formData.class12SchoolId)?.code || '—'), 1)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _hoisted_23,
                    _createVNode(_component_el_select, {
                      "popper-class": "umt-form-dd",
                      class: "w-100",
                      placeholder: "Tỉnh / Thành phố",
                      modelValue: _ctx.formData.class11ProvinceId,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.class11ProvinceId) = $event)),
                      onChange: _ctx.schoolProcess11ProvinceChange,
                      filterable: true,
                      disabled: !_ctx.isEdit
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataProvinceForSchool, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.name,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange", "disabled"]),
                    _createElementVNode("div", _hoisted_24, [
                      _createTextVNode("Mã tỉnh: "),
                      _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.dataProvinceForSchool.find(i => i.id === _ctx.formData.class11ProvinceId)?.code || '—'), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _hoisted_27,
                    _createVNode(_component_el_select, {
                      "popper-class": "umt-form-dd",
                      class: "w-100",
                      placeholder: "Chọn / gõ tìm trường",
                      modelValue: _ctx.formData.class11SchoolId,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.class11SchoolId) = $event)),
                      onChange: _ctx.schoolProcess11SchoolNameChange,
                      disabled: _ctx.schoolProcess11SchoolNameOption.length == 0 || !_ctx.isEdit,
                      filterable: true
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.schoolProcess11SchoolNameOption, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.districtName ? `${item.name} - ${item.districtName}` : item.name,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange", "disabled"]),
                    _createElementVNode("div", _hoisted_28, [
                      _createTextVNode("Mã trường: "),
                      _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.schoolProcess11SchoolNameOption.find(i => i.id === _ctx.formData.class11SchoolId)?.code || '—'), 1)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _hoisted_35,
                    _createVNode(_component_el_select, {
                      "popper-class": "umt-form-dd",
                      class: "w-100",
                      placeholder: "Tỉnh / Thành phố",
                      modelValue: _ctx.formData.class10ProvinceId,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.class10ProvinceId) = $event)),
                      name: "class10ProvinceId",
                      onChange: _ctx.schoolProcessProvinceChange,
                      filterable: true,
                      disabled: !_ctx.isEdit
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataProvinceForSchool, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.name,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange", "disabled"]),
                    _createElementVNode("div", _hoisted_36, [
                      _createTextVNode("Mã tỉnh: "),
                      _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.dataProvinceForSchool.find(i => i.id === _ctx.formData.class10ProvinceId)?.code || '—'), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _hoisted_39,
                    _createVNode(_component_el_select, {
                      "popper-class": "umt-form-dd",
                      class: "w-100",
                      placeholder: "Chọn / gõ tìm trường",
                      modelValue: _ctx.formData.class10SchoolId,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.class10SchoolId) = $event)),
                      onChange: _ctx.schoolProcessSchoolNameChange,
                      disabled: _ctx.schoolProcess10SchoolNameOption.length == 0 || !_ctx.isEdit,
                      filterable: true
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.schoolProcess10SchoolNameOption, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.districtName ? `${item.name} - ${item.districtName}` : item.name,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange", "disabled"]),
                    _createElementVNode("div", _hoisted_40, [
                      _createTextVNode("Mã trường: "),
                      _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.schoolProcess10SchoolNameOption.find(i => i.id === _ctx.formData.class10SchoolId)?.code || '—'), 1)
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["mb-5 mt-2", _ctx.isEdit ? '' : 'd-none'])
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              id: "checkSameClass12",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.sameAsClass12) = $event)),
              onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.applySameAsClass12 && _ctx.applySameAsClass12(...args)))
            }, null, 544), [
              [_vModelCheckbox, _ctx.sameAsClass12]
            ]),
            _hoisted_42
          ], 2),
          _createElementVNode("div", _hoisted_43, [
            _hoisted_44,
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _hoisted_47,
                _createVNode(_component_el_select, {
                  "popper-class": "umt-form-dd",
                  class: "w-100",
                  placeholder: "Chọn năm tốt nghiệp",
                  modelValue: _ctx.formData.graduatedYear,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.graduatedYear) = $event)),
                  disabled: !_ctx.isEdit,
                  filterable: true
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.graduatedYearOptions, (y) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: y,
                        label: y,
                        value: y
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _createElementVNode("div", _hoisted_48, [
                _hoisted_49,
                _createVNode(_component_el_input, {
                  type: "text",
                  class: "w-100",
                  disabled: !_ctx.isEdit,
                  name: "orderNumber",
                  modelValue: _ctx.formData.orderNumber,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.orderNumber) = $event)),
                  placeholder: "Số báo danh"
                }, null, 8, ["disabled", "modelValue"])
              ]),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("label", {
                  class: _normalizeClass(["form-label fw-semibold mb-2", { required: _ctx.needCertificate }]),
                  title: "Số hiệu in trên văn bằng tốt nghiệp — bắt buộc khi ứng viên tốt nghiệp từ năm trước (đã có bằng)"
                }, [
                  _createTextVNode("Số hiệu bằng TN "),
                  _hoisted_51
                ], 2),
                _createVNode(_component_el_input, {
                  type: "text",
                  class: "w-100",
                  disabled: !_ctx.isEdit,
                  name: "certificateNumber",
                  modelValue: _ctx.formData.certificateNumber,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.certificateNumber) = $event)),
                  placeholder: "Số hiệu bằng"
                }, null, 8, ["disabled", "modelValue"])
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["col-md-4", _ctx.isOnlyArticulation ? 'd-none' : ''])
              }, [
                _hoisted_52,
                _createVNode(_component_el_select, {
                  "popper-class": "umt-form-dd",
                  class: "w-100",
                  placeholder: "Đối tượng ưu tiên",
                  modelValue: _ctx.formData.priorityObject,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.priorityObject) = $event)),
                  disabled: !_ctx.isEdit,
                  filterable: true
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "Không ưu tiên",
                      value: "00"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Không ưu tiên")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "01",
                      value: "01"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("01")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "02",
                      value: "02"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("02")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "03",
                      value: "03"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("03")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "04",
                      value: "04"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("04")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "05",
                      value: "05"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("05")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "06",
                      value: "06"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("06")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "07",
                      value: "07"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("07")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["col-md-4", _ctx.isOnlyArticulation ? 'd-none' : ''])
              }, [
                _hoisted_53,
                _createVNode(_component_el_select, {
                  "popper-class": "umt-form-dd",
                  class: "w-100",
                  placeholder: "Khu vực ưu tiên",
                  modelValue: _ctx.formData.priorityArea,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.priorityArea) = $event)),
                  disabled: !_ctx.isEdit,
                  filterable: true
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "KV1",
                      value: "KV1"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("KV1")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "KV2",
                      value: "KV2"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("KV2")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "KV2NT",
                      value: "KV2NT"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("KV2NT")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, {
                      label: "KV3",
                      value: "KV3"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("KV3")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["col-md-4 text-center", _ctx.isOnlyArticulation ? 'd-none' : ''])
              }, [
                _hoisted_54,
                _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.sumPointPriority), 1)
              ], 2)
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["border border-gray-300 border-dashed rounded p-5 mb-5", _ctx.isOnlyArticulation ? 'd-none' : ''])
          }, [
            _createElementVNode("div", _hoisted_56, [
              _hoisted_57,
              _createTextVNode(" Bảng điểm học bạ THPT (TB cả năm) "),
              _createElementVNode("span", {
                class: _normalizeClass(["ms-auto", _ctx.isEdit ? '' : 'd-none']),
                style: {"text-transform":"none","font-weight":"400"}
              }, [
                _createElementVNode("span", {
                  class: "btn btn-sm btn-light-primary umt-btn-32",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showTranscriptDrawer = true))
                }, [
                  _hoisted_58,
                  _createTextVNode("Nhập điểm ")
                ])
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("table", _hoisted_60, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", _hoisted_61, [
                    _hoisted_62,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transcriptSubjects, (sub) => {
                      return (_openBlock(), _createElementBlock("th", {
                        key: sub.value,
                        class: "text-center",
                        title: sub.label
                      }, _toDisplayString(sub.short || sub.label), 9, _hoisted_63))
                    }), 128))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transcriptYears, (year) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: year.key
                    }, [
                      _createElementVNode("td", _hoisted_64, _toDisplayString(year.label), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transcriptSubjects, (sub) => {
                        return (_openBlock(), _createElementBlock("td", {
                          key: sub.value,
                          class: _normalizeClass(["text-center fw-semibold", _ctx.formData.transcript?.[sub.value]?.[year.key] != null ? 'text-gray-800' : 'text-gray-400'])
                        }, _toDisplayString(_ctx.formData.transcript?.[sub.value]?.[year.key] ?? '—'), 3))
                      }), 128))
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _hoisted_65,
            _createVNode(_component_el_drawer, {
              modelValue: _ctx.showTranscriptDrawer,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.showTranscriptDrawer) = $event)),
              direction: "rtl",
              size: "600px",
              "with-header": false,
              "append-to-body": ""
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("div", _hoisted_67, [
                    _hoisted_68,
                    _createElementVNode("span", {
                      class: "btn btn-sm btn-icon btn-active-light-primary",
                      title: "Đóng",
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.showTranscriptDrawer = false))
                    }, [
                      _createElementVNode("span", _hoisted_69, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_70, [
                    _hoisted_71,
                    _createElementVNode("div", _hoisted_72, [
                      _createElementVNode("table", _hoisted_73, [
                        _hoisted_74,
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transcriptSubjects, (sub) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: sub.value
                            }, [
                              _createElementVNode("td", _hoisted_75, _toDisplayString(sub.label), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transcriptYears, (year) => {
                                return (_openBlock(), _createElementBlock("td", {
                                  key: year.key,
                                  class: "text-center"
                                }, [
                                  _createVNode(_component_el_input, {
                                    type: "number",
                                    class: "w-90px input-custom transcript-input",
                                    "model-value": _ctx.formData.transcript?.[sub.value]?.[year.key],
                                    "onUpdate:modelValue": ($event: any) => (_ctx.setTranscriptScore(sub.value, year.key, $event)),
                                    onChange: ($event: any) => (_ctx.normalizeTranscriptScore(sub.value, year.key)),
                                    onKeyup: _cache[15] || (_cache[15] = _withKeys(($event: any) => (_ctx.focusNextTranscriptInput($event)), ["enter"])),
                                    placeholder: "—"
                                  }, null, 8, ["model-value", "onUpdate:modelValue", "onChange"])
                                ]))
                              }), 128))
                            ]))
                          }), 128))
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_76, [
                      _hoisted_77,
                      _createElementVNode("span", {
                        class: "btn btn-primary umt-btn-32",
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.showTranscriptDrawer = false))
                      }, "Xong")
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ], 2),
          _createElementVNode("div", {
            id: "grad-score-card",
            class: _normalizeClass(["border border-gray-300 border-dashed rounded p-5 mb-5", _ctx.isOnlyArticulation ? 'd-none' : ''])
          }, [
            _createElementVNode("div", _hoisted_78, [
              _hoisted_79,
              _createTextVNode(" Bảng điểm thi tốt nghiệp THPT 2026 "),
              _createElementVNode("span", {
                class: _normalizeClass(["ms-auto", _ctx.isEdit ? '' : 'd-none']),
                style: {"text-transform":"none","font-weight":"400"}
              }, [
                _createElementVNode("span", {
                  class: "btn btn-sm btn-light-primary umt-btn-32",
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.showGradScoreDrawer = true))
                }, [
                  _hoisted_80,
                  _createTextVNode("Nhập điểm ")
                ])
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_81, [
              _createElementVNode("table", _hoisted_82, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", _hoisted_83, [
                    _hoisted_84,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gradScoreSubjects, (sub) => {
                      return (_openBlock(), _createElementBlock("th", {
                        key: sub.value,
                        class: "text-center",
                        title: sub.label
                      }, _toDisplayString(sub.short || sub.label), 9, _hoisted_85))
                    }), 128))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_86,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gradScoreSubjects, (sub) => {
                      return (_openBlock(), _createElementBlock("td", {
                        key: sub.value,
                        class: _normalizeClass(["text-center fw-semibold", _ctx.formData.graduationscore?.[sub.value] != null ? 'text-gray-800' : 'text-gray-400'])
                      }, _toDisplayString(_ctx.formData.graduationscore?.[sub.value] ?? '—'), 3))
                    }), 128))
                  ])
                ])
              ])
            ]),
            _hoisted_87,
            _createVNode(_component_el_drawer, {
              modelValue: _ctx.showGradScoreDrawer,
              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.showGradScoreDrawer) = $event)),
              direction: "rtl",
              size: "440px",
              "with-header": false,
              "append-to-body": ""
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_88, [
                  _createElementVNode("div", _hoisted_89, [
                    _hoisted_90,
                    _createElementVNode("span", {
                      class: "btn btn-sm btn-icon btn-active-light-primary",
                      title: "Đóng",
                      onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.showGradScoreDrawer = false))
                    }, [
                      _createElementVNode("span", _hoisted_91, [
                        _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_92, [
                    _hoisted_93,
                    _createElementVNode("div", _hoisted_94, [
                      _createElementVNode("table", _hoisted_95, [
                        _hoisted_96,
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gradScoreSubjects, (sub) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: sub.value
                            }, [
                              _createElementVNode("td", _hoisted_97, _toDisplayString(sub.label), 1),
                              _createElementVNode("td", _hoisted_98, [
                                _createVNode(_component_el_input, {
                                  type: "number",
                                  class: "w-90px input-custom gradscore-input",
                                  "model-value": _ctx.formData.graduationscore?.[sub.value],
                                  "onUpdate:modelValue": ($event: any) => (_ctx.setGradScore(sub.value, $event)),
                                  onChange: ($event: any) => (_ctx.normalizeGradScore(sub.value)),
                                  onKeyup: _cache[20] || (_cache[20] = _withKeys(($event: any) => (_ctx.focusNextGradScoreInput($event)), ["enter"])),
                                  placeholder: "—"
                                }, null, 8, ["model-value", "onUpdate:modelValue", "onChange"])
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_99, [
                      _hoisted_100,
                      _createElementVNode("span", {
                        class: "btn btn-primary umt-btn-32",
                        onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.showGradScoreDrawer = false))
                      }, "Xong")
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["border border-gray-300 border-dashed rounded p-5 mb-5", _ctx.isArticulationStudent ? '' : 'd-none'])
          }, [
            _hoisted_101,
            _createElementVNode("div", _hoisted_102, [
              _createElementVNode("div", _hoisted_103, [
                _hoisted_104,
                _createVNode(_component_el_input, {
                  type: "text",
                  class: "w-100",
                  disabled: true,
                  modelValue: _ctx.formData._arpros.graduationschool,
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.formData._arpros.graduationschool) = $event)),
                  placeholder: "—"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_105, [
                _hoisted_106,
                _createVNode(_component_el_select, {
                  "popper-class": "umt-form-dd",
                  class: "w-100",
                  placeholder: "—",
                  modelValue: _ctx.formData._arpros.trainingform,
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.formData._arpros.trainingform) = $event)),
                  disabled: true
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "Chính quy",
                      value: "chinhquy"
                    }),
                    _createVNode(_component_el_option, {
                      label: "Nghề",
                      value: "nghe"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_107, [
                _hoisted_108,
                _createVNode(_component_el_select, {
                  "popper-class": "umt-form-dd",
                  class: "w-100",
                  placeholder: "—",
                  modelValue: _ctx.formData._arpros.graduationsys,
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.formData._arpros.graduationsys) = $event)),
                  disabled: true
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "Trung cấp",
                      value: "trungcap"
                    }),
                    _createVNode(_component_el_option, {
                      label: "Cao đẳng",
                      value: "caodang"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_109, [
                _hoisted_110,
                _createVNode(_component_el_radio_group, {
                  class: "d-block mt-1",
                  disabled: true,
                  modelValue: _ctx.formData._arpros.gpafor,
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.formData._arpros.gpafor) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, {
                      label: "gpa4",
                      class: "me-6"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Hệ 4")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: "gpa10" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Hệ 10")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_111, [
                _createElementVNode("label", _hoisted_112, [
                  _createTextVNode("Điểm trung bình"),
                  _createElementVNode("span", _hoisted_113, _toDisplayString(_ctx.arproGpaScaleHint), 1)
                ]),
                _createVNode(_component_el_input, {
                  type: "text",
                  class: "w-100",
                  disabled: true,
                  modelValue: _ctx.formData._arpros.gpa,
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.formData._arpros.gpa) = $event)),
                  placeholder: "—"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_114, [
                _hoisted_115,
                _createVNode(_component_el_input, {
                  type: "text",
                  class: "w-100",
                  disabled: true,
                  modelValue: _ctx.formData._arpros.graduationnumber,
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.formData._arpros.graduationnumber) = $event)),
                  placeholder: "—"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_116, [
                _hoisted_117,
                _createVNode(_component_el_input, {
                  type: "text",
                  class: "w-100",
                  disabled: true,
                  modelValue: _ctx.formData._arpros.graduationentrynumber,
                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.formData._arpros.graduationentrynumber) = $event)),
                  placeholder: "—"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_118, [
                _hoisted_119,
                _createVNode(_component_el_input, {
                  type: "text",
                  class: "w-100",
                  disabled: true,
                  modelValue: _ctx.formData._arpros.graduationyear,
                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.formData._arpros.graduationyear) = $event)),
                  placeholder: "—"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_120, [
                _hoisted_121,
                _createVNode(_component_el_date_picker, {
                  class: "w-100",
                  type: "date",
                  format: "DD/MM/YYYY",
                  "value-format": "YYYY-MM-DD",
                  placeholder: "—",
                  modelValue: _ctx.formData._arpros.graduationday,
                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.formData._arpros.graduationday) = $event)),
                  disabled: true
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_122, [
              _createElementVNode("label", _hoisted_123, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input me-3",
                  type: "checkbox",
                  disabled: true,
                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.formData._arpros.isintermediate) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.formData._arpros.isintermediate]
                ]),
                _hoisted_124
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["border border-gray-300 rounded p-4 mt-3", _ctx.formData._arpros.isintermediate ? '' : 'd-none'])
              }, [
                _hoisted_125,
                _hoisted_126,
                _createElementVNode("div", _hoisted_127, [
                  _createElementVNode("div", _hoisted_128, [
                    _hoisted_129,
                    _createVNode(_component_el_input, {
                      type: "text",
                      class: "w-100",
                      disabled: true,
                      modelValue: _ctx.formData._arpros.intermediate.graduationschool,
                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.formData._arpros.intermediate.graduationschool) = $event)),
                      placeholder: "—"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_130, [
                    _hoisted_131,
                    _createVNode(_component_el_select, {
                      "popper-class": "umt-form-dd",
                      class: "w-100",
                      placeholder: "—",
                      modelValue: _ctx.formData._arpros.intermediate.trainingform,
                      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.formData._arpros.intermediate.trainingform) = $event)),
                      disabled: true
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "Chính quy",
                          value: "chinhquy"
                        }),
                        _createVNode(_component_el_option, {
                          label: "Nghề",
                          value: "nghe"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_132, [
                    _hoisted_133,
                    _createVNode(_component_el_input, {
                      type: "text",
                      class: "w-100",
                      disabled: true,
                      modelValue: _ctx.formData._arpros.intermediate.graduationyear,
                      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.formData._arpros.intermediate.graduationyear) = $event)),
                      placeholder: "—"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_134, [
                    _hoisted_135,
                    _createVNode(_component_el_input, {
                      type: "text",
                      class: "w-100",
                      disabled: true,
                      modelValue: _ctx.formData._arpros.intermediate.graduationnumber,
                      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.formData._arpros.intermediate.graduationnumber) = $event)),
                      placeholder: "—"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_136, [
                    _hoisted_137,
                    _createVNode(_component_el_input, {
                      type: "text",
                      class: "w-100",
                      disabled: true,
                      modelValue: _ctx.formData._arpros.intermediate.graduationentrynumber,
                      "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.formData._arpros.intermediate.graduationentrynumber) = $event)),
                      placeholder: "—"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_138, [
                    _hoisted_139,
                    _createVNode(_component_el_date_picker, {
                      class: "w-100",
                      type: "date",
                      format: "DD/MM/YYYY",
                      "value-format": "YYYY-MM-DD",
                      placeholder: "—",
                      modelValue: _ctx.formData._arpros.intermediate.graduationday,
                      "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.formData._arpros.intermediate.graduationday) = $event)),
                      disabled: true
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_140, [
              _createElementVNode("div", _hoisted_141, _toDisplayString(_ctx.arproEditNote), 1),
              _withDirectives(_createVNode(_component_router_link, {
                to: { path: `/hosoungvien/${_ctx.formData._arpros?.adregid || ''}`, query: { from: 'ungvien' } },
                class: "btn btn-sm btn-light-primary umt-btn-32 text-nowrap"
              }, {
                default: _withCtx(() => [
                  _hoisted_142,
                  _createTextVNode("Mở hồ sơ liên thông để sửa ")
                ]),
                _: 1
              }, 8, ["to"]), [
                [_vShow, _ctx.formData._arpros && _ctx.formData._arpros.adregid && !_ctx.arproWon]
              ])
            ])
          ], 2),
          (_ctx.isEdit)
            ? (_openBlock(), _createElementBlock("div", _hoisted_143, [
                (!_ctx.isAddProfile)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: "btn btn-light me-3",
                      onClick: _cache[39] || (_cache[39] = 
//@ts-ignore
(...args) => (_ctx.loadDefaultData && _ctx.loadDefaultData(...args)))
                    }, "Hủy bỏ"))
                  : _createCommentVNode("", true),
                (_ctx.isAddProfile)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 1,
                      to: "/danhsachungvien",
                      class: "btn btn-light me-3"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Hủy bỏ")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "submit",
                  class: "btn btn-primary",
                  disabled: _ctx.saving
                }, [
                  (_ctx.saving)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_145))
                    : _createCommentVNode("", true),
                  _createTextVNode(_toDisplayString(_ctx.isAddProfile?'Lưu thông tin':'Lưu thay đổi'), 1)
                ], 8, _hoisted_144)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["model", "rules"])
  ], 2))
}